// extracted by css-extract-rspack-plugin
export default {"message":"message-hHc8jr","actionsButton":"actionsButton-ffoZN1"};